import React from "react";
import HeadImg from "../../../assets/Exactness/Header/Bg.svg";
import Line from "../../../assets/line2.svg";

const Header = () => {
  return (
    <div className="relative flex h-[99vh] min-[380px]:h-[85vh] min-[473px]:h-[75vh] lg:h-[65vh] 2xl:h-[60vh] flex-col">
      <img
        src={HeadImg}
        alt="Header Background"
        className="bottom-0 left-0 w-full h-[78vh] lg:h-[65vh] 2xl:h-[60vh] object-cover"
      />
      <div className="absolute py-7 px-5 flex flex-col items-center z-10 inset-0">
        <div className="text-center w-full sm:w-[90%] md:w-[95%] lg:w-[85%] mb-8 mt-2 lg:mt-0 min-[1090px]:mt-8">
          <p className="text-xl text-[1.7rem] font-medium leading-[1.67] text-gray-700">
            Pricing
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
            Flexible{" "}
            <span className="relative inline-block">
              Pricing
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>{" "}
            Plans for Every Need
          </h2>
          <p className="text-xl md:text-2xl my-6">
            Transparent and flexible pricing options.
          </p>
          <p className="text-xl md:text-2xl mt-4 mb-6">
            Individuals, small businesses, and large companies can all access
            reliable, verified email addresses with our affordable plans.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;
